// Helper function to handle docs redirects
const createDocsRedirect = (docsUrl, sliceLength) => {
  return (to, from, next) => {
    const path = to.path.slice(sliceLength)
    const cleanDocsUrl = docsUrl.replace(/\/$/, '')
    const cleanPath = path.startsWith('/') ? path : '/' + path

    // Preserve any query string / hash (e.g. the ?fa_session login hint) across the redirect.
    const suffix = to.fullPath.slice(to.path.length)

    // Redirecting with window.location.assign, so we must cancel Vue Router navigation with next(false)
    window.location.assign(cleanDocsUrl + cleanPath + suffix)
    next(false)
  }
}

// Configuration object for changelog routing conditions
const CHANGELOG_ROUTES = {
  '/docs/changelog': '/changelog',
  '/v6/docs/changelog': '/changelog',
  '/v5/docs/changelog': '/changelog/v5'
}

// Helper function to handle changelog redirects
const createChangelogRedirect = (to, from, next) => {
  for (const [prefix, redirectPath] of Object.entries(CHANGELOG_ROUTES)) {
    if (to.path.startsWith(prefix)) {
      next(redirectPath)
      return
    }
  }
  createDocsRedirect(FONTAWESOME.DOCS_URL, 5)(to, from, next)
}

// Router 3's trailing `*` was a wildcard that captured the rest of the path as
// `params.pathMatch`. Router 4 has no such wildcard — a bare `*` after literal
// text is matched literally, so `/docs*` matched only the path `/docs*` and
// every real docs URL fell through to the catch-all and rendered Not Found.
//
// `:pathMatch(.*)*` is the documented equivalent, and the same form the global
// catch-all in routes/index.js already uses. The repeat modifier matters: a
// plain `(.*)` matches fine but cannot BUILD these links, because Router 4
// percent-encodes the slashes inside a non-repeatable param
// (`/v6/docs%2Fweb%2Fsetup`) and rejects an empty value as a missing required
// param. The repeatable form takes an array of segments instead, so
// `docsPathMatch()` converts the string paths the call sites use.
//
// `/docs` still matches, with `pathMatch` an empty array. The redirects below
// read `to.path`, so their slice offsets are unaffected.
let docPaths = []

docPaths.push({
  path: `/v5/docs/:pathMatch(.*)*`,
  name: `five.docs`,
  beforeEnter: createDocsRedirect(FONTAWESOME.V5_DOCS_URL, 9)
})

docPaths.push({
  path: `/v6/docs/:pathMatch(.*)*`,
  name: `six.docs`,
  beforeEnter: createDocsRedirect(FONTAWESOME.V6_DOCS_URL, 9)
})

docPaths.push({
  path: `/docs/:pathMatch(.*)*`,
  name: `latest.docs`,
  beforeEnter: createChangelogRedirect
})

/**
 * Turns a docs path into the segment array a repeatable route param needs.
 * `'/web/troubleshoot'` -> `['web', 'troubleshoot']`; `''` -> `[]`.
 */
export const docsPathMatch = (path = '') => String(path).split('/').filter(Boolean)

export default docPaths
